
// import React from 'react';

// // Helper: generate dynamic ranges for labels
// function generateDynamicRanges(breaks) {
//     if (!breaks || breaks.length < 2) return [];

//     const allIntegers = breaks.every(b => Number.isInteger(b));
//     const ranges = [];

//     for (let i = 0; i < breaks.length - 1; i++) {
//         const start = breaks[i];
//         const next = breaks[i + 1];
//         const diff = next - start;
//         let end;

//         if (allIntegers) {
//             const decrement = Math.max(Math.ceil(diff * 0.05), 1);
//             end = next - decrement;
//             if (end <= start) end = next - 1;
//         } else {
//             const decrement = diff * 0.33;
//             end = +(start + diff - decrement).toFixed(2);
//         }

//         ranges.push(`${start} to ${end}`);
//     }

//     ranges.push(`${breaks[breaks.length - 2]} to ${breaks[breaks.length - 1]}`);
//     return ranges;
// }

// // Scale radius based on number of breaks
// function getRadii(breaks) {
//     const maxRadii = [2, 5, 10, 15, 20];
//     if (breaks.length >= 5) return maxRadii;
//     return [20, 15, 10, 5, 2].slice(0, breaks.length);
// }

// const SingleIndicatorLegend = ({ setMapConfigData, breaks, colors }) => {
//     if (!setMapConfigData || !breaks || breaks.length < 2) return null;

//     const chartType = setMapConfigData?.chartType || 'bubble';
//     const indicator = setMapConfigData?.indicator;
//     const reversedColors = [...colors].reverse();
//     const rangeLabels = generateDynamicRanges(breaks);

//     const radii = chartType === 'bubble' ? getRadii(breaks) : null;

//     const getShapeStyle = (color, radius) => {
//         switch (chartType) {
//             case 'marker':
//                 return {
//                     width: 0,
//                     height: 0,
//                     borderLeft: '10px solid transparent',
//                     borderRight: '10px solid transparent',
//                     borderBottom: `20px solid ${colors[colors.length - 1]}`,
//                     marginBottom: 4,
//                 };
//             case 'bubble':
//             default:
//                 return {
//                     width: radius * 2,
//                     height: radius * 2,
//                     borderRadius: '50%',
//                     backgroundColor: color,
//                     opacity: 0.4,
//                     border: `2px solid ${color}`,
//                     marginBottom: 4,
//                 };
//         }
//     };

//     return (
//         <div className="legend-box bg-white border rounded shadow p-3 mt-2 gap-4">
//             <div className="d-flex flex-column align-items-center gap-3">
//                 {breaks.map((_, i) => {
//                     if (i >= breaks.length - 1) return null;

//                     const radius = radii ? radii[i] : 10;
//                     const color = chartType === 'bubble' ? reversedColors[i] : colors[colors.length - 1];

//                     return (
//                         <div key={i} className="d-flex flex-column align-items-center">
//                             <div style={getShapeStyle(color, radius)}></div>
//                             <small className="text-center mt-1" style={{ fontSize: '0.75rem' }}>
//                                 {rangeLabels[i]}
//                             </small>
//                         </div>
//                     );
//                 })}
//             </div>
//             <div className="fw-bold mb-2 text-center">
//                 {indicator.label}{indicator.subLabel ? ` | [${indicator.subLabel}]` : ''}
//             </div>
//         </div>
//     );
// };

// export default SingleIndicatorLegend;import React from 'react';

// Helper: generate dynamic ranges for labels
function generateDynamicRanges(breaks) {
    if (!breaks || breaks.length < 2) return [];

    const allIntegers = breaks.every(b => Number.isInteger(b));
    const ranges = [];

    for (let i = 0; i < breaks.length - 1; i++) {
        const start = breaks[i];
        const next = breaks[i + 1];
        const diff = next - start;
        let end;

        if (allIntegers) {
            const decrement = Math.max(Math.ceil(diff * 0.05), 1);
            end = next - decrement;
            if (end <= start) end = next - 1;
        } else {
            const decrement = diff * 0.33;
            end = +(start + diff - decrement).toFixed(2);
        }

        ranges.push(`${start} to ${end}`);
    }

    ranges.push(`${breaks[breaks.length - 2]} to ${breaks[breaks.length - 1]}`);
    return ranges;
}

// Scale sizes for markers/bubbles
function getSizes(breaks) {
    const maxSizes = [5, 10, 15, 20, 25]; // max size for marker/bubble
    if (breaks.length >= 5) return maxSizes;
    return [25, 20, 15, 10, 5].slice(0, breaks.length);
}

const SingleIndicatorLegend = ({ setMapConfigData, breaks, colors }) => {
    if (!setMapConfigData || !breaks || breaks.length < 2) return null;

    const chartType = setMapConfigData?.chartType || 'bubble';
    const indicator = setMapConfigData?.indicator;
    const rangeLabels = generateDynamicRanges(breaks);
    const sizes = getSizes(breaks);

    const getShapeStyle = (color, size) => {
        if (chartType === 'marker') {
            return {
                width: 0,
                height: 0,
                borderLeft: '10px solid transparent',
                borderRight: '10px solid transparent',
                borderBottom: `20px solid ${color}`,
                marginBottom: 4,
            };
        }

        // bubble
        return {
            width: size * 2,
            height: size * 2,
            borderRadius: '50%',
            backgroundColor: colors[colors.length - 2],
            opacity: 0.4,
            border: `3px solid ${colors[colors.length - 2]}`,
            marginBottom: 4,
        };
    };

    return (
        <div className="container-fluid bg-white border rounded shadow p-3 mt-2 gap-4">
            <div className="d-flex flex-column align-items-center gap-3">
                {breaks.map((_, i) => {
                    if (i >= breaks.length - 1) return null;

                    const size = sizes[i];
                    const color = colors[colors.length - 1 - i] || colors[0]; // unique color for each marker

                    return (
                        <div key={i} className="d-flex flex-column align-items-center">
                            <div style={getShapeStyle(color, size)}></div>
                            <small
                                className="text-center mt-1"
                                style={{ fontSize: '0.75rem' }}
                            >
                                {rangeLabels[i]}
                            </small>
                        </div>
                    );
                })}
            </div>
            <div className="fw-bold mb-2 text-center">
                {indicator.label}{indicator.subLabel ? ` | [${indicator.subLabel}]` : ''}
            </div>
        </div>
    );
};

export default SingleIndicatorLegend;
